// 会話スレッドの自動スクロール (spec: docs/superpowers/specs/2026-07-27-thread-auto-scroll-design.md)。
// 判定と DOM 操作だけを持ち、React もアプリの状態も知らない。React 配線は
// src/hooks/useFollowBottom.ts が担う。

/** 「最下部付近」とみなす距離 (px)。これ以内なら追従を続ける (spec D2)。 */
export const NEAR_BOTTOM_PX = 120;

// スクロール領域として読み書きする最小の形。DOM 要素はこれを満たすので、
// テストでは素のオブジェクトを渡せる (jsdom は scrollHeight / clientHeight を
// 常に 0 で返し、Element.prototype.scrollTo を持たない。spec §6.1)。
export type ScrollBox = {
  scrollTop: number;
  readonly scrollHeight: number;
  readonly clientHeight: number;
  scrollTo?: (options: { top: number; behavior?: "auto" | "smooth" }) => void;
};

/**
 * 最下部から thresholdPx 以内にいるか。追従を続けるかの判断に使う。
 * 判定はスクロール操作の時点で行う (バブルが増えた後に測ると、背の高いバブルが
 * 1 つ増えただけで「ユーザーが上にいる」と誤判定する。spec §3.3)。
 */
export function isNearBottom(box: ScrollBox, thresholdPx: number = NEAR_BOTTOM_PX): boolean {
  return box.scrollHeight - box.scrollTop - box.clientHeight <= thresholdPx;
}

/**
 * 最下部へ送る。アニメーションを付けない (spec D3): smooth はアニメーション中も
 * scroll event を撒くため isNearBottom が「ユーザーが上にいる」と誤読し、追従を
 * 落としたうえ古い scrollHeight を目標にしたアニメが途中で止まる。
 */
export function scrollToBottom(box: ScrollBox | null | undefined): void {
  if (!box) return;
  box.scrollTop = box.scrollHeight;
}

/**
 * 最上部へ送る (Review で「修正する」と言われたとき)。意図した大きな移動では
 * 動きが方向を伝えるので smooth を使い、scrollTo を持たない環境では即時に倒す。
 */
export function scrollToTop(box: ScrollBox | null | undefined): void {
  if (!box) return;
  if (typeof box.scrollTo === "function") box.scrollTo({ top: 0, behavior: "smooth" });
  else box.scrollTop = 0;
}
